'use client';

import { ConvexProvider, ConvexReactClient } from 'convex/react';
import React from 'react';

const convex = new ConvexReactClient(process.env.NEXT_PUBLIC_CONVEX_URL);

export default function ConvexClientProvider({ children }) {
  return <ConvexProvider data-component-id="src/components/ConvexClientProvider.jsx:9:9" data-component-path="src/components/ConvexClientProvider.jsx" data-component-line="9" data-component-end-line="9" data-component-file="ConvexClientProvider.jsx" data-component-name="ConvexProvider" data-component-content="%7B%22elementName%22%3A%22ConvexProvider%22%7D" client={convex}>{children}</ConvexProvider>;
}
